module.exports = __webpack_public_path__ + "media/images/baba-fe5635dbc6d9770d000bea21416bc9ae.jpg";